// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import {
  getCountry,
  getGatewayVoucherUrl,
  usePendingIncomingPayment,
  type PendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { Button } from '../../../commons/atoms';

export function PrintInstructionsButton(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <PrintButton
      as="a"
      href={getGatewayVoucherUrl(incomingPayment)}
      outlineColor="#2397d4"
      rel="noopener noreferrer"
      target="_blank"
      type="transparent"
    >
      <ButtonText incomingPayment={incomingPayment} />
    </PrintButton>
  );
}

type ButtonTextProps = {
  incomingPayment: PendingIncomingPayment,
};

function ButtonText({ incomingPayment }: ButtonTextProps): Node {
  const country = getCountry(incomingPayment);
  switch (country) {
    case 'bo':
      return 'IMPRIMIR INSTRUCCIONES';
    default:
      throw new Error(`Country "${country}" not supported`);
  }
}

const PrintButton = styled(Button)`
  display: none;
  border-radius: 5px;
  width: 100%;
  color: #2397d4;
  font-weight: bold;
  @media (min-width: 990px) {
    display: block;
  }
`;
